import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Spin,
  Icon,
  Button,
  Select,
  Popconfirm,
  message,
  Alert
} from 'antd';
const { Option } = Select;
import {
  ssrHandler,
  fetchJobs,
  sortingChange,
  sortingJobs,
  fetchEc2Machine,
  rebootMachine
} from '../actions/sessionActions';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const columns = [
  {
    title: 'Name',
    key: 'name'
  },
  {
    title: 'Running State',
    key: 'state'
  },
  {
    title: 'Started',
    key: 'started'
  },
  {
    title: 'Current',
    key: 'current'
  },
  {
    title: 'Updated',
    key: 'updated'
  },
  {
    title: 'Server',
    key: 'server'
  },
  {
    title: 'URL',
    key: 'url'
  }
];

export class Jobs extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
    // await dispatch(fetchJobs());
  }
  constructor() {
    super();
    this.state = {
      ec2: []
    };
  }

  _jobSorting = (e, name) => {
    let { key, order } = this.props.jobs.sorting;
    if (key === name) {
      if (order === -1) {
        order = 0;
      } else {
        order = order === 1 ? 0 : 1;
      }
    } else {
      key = name;
      order = 0;
    }
    this.props.sortingChange({ key, order });
    this.props.sortingJobs();
  };

  componentWillMount() {
    const { config, match } = this.props;
    if (match.path !== config.route && config.route !== '' && config.ssr) {
      // this.props.fetchJobs();
    }
  }

  componentDidMount() {
    this.props.fetchJobs().then(() => {
      this.props.fetchEc2Machine().then(res => {
        if (this.props.jobs.list.length > 0) {
          const downJobs =
            this.props.jobs &&
            this.props.jobs.list &&
            this.props.jobs.list
              .find(item => item.priority === 1)
              .list.map(job => job.server);
          const uniqueJobs = new Set(downJobs);
          const machines = [...new Set(res.result)];
          let ec2 = [];
          machines.forEach(machine => {
            if ([...uniqueJobs].indexOf(machine.name) > -1) {
              ec2.push(machine.instance_id);
            }
          });
          this.setState({ ec2 });
        }
      });
    });
  }

  handleChange = (key, value) => {
    this.setState({ [key]: value });
  };

  reset = () => {
    this.setState({ ec2: [] });
  };

  confirm = () => {
    const { ec2 } = this.state;
    this.props.rebootMachine(ec2).then(res => {
      if (res.meta.status === 200) {
        message.success('Reboot request has been initiated');
        this.setState({ ec2: [] });
      } else {
        message.error(res.meta.message);
      }
    });
  };

  cancel = () => {
    return message.info('It seems, you have selected No');
  };

  render() {
    const { jobs } = this.props;
    return (
      <div>
        <Row className="margin-bottom-10 view-header">
          <Col
            sm={24}
            md={2}
            lg={2}
            xl={2}
            style={{ marginTop: '5px', fontSize: '14px' }}
          >
            Instances:
          </Col>
          <Col sm={24} md={16} lg={16} xl={16}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                mode="multiple"
                name="ec2"
                id="ec2"
                showSearch
                style={{ width: '100%' }}
                placeholder="Select ec2 machine"
                optionFilterProp="children"
                value={this.state.ec2 ? this.state.ec2 : undefined}
                onChange={value => this.handleChange('ec2', value)}
                allowClear={true}
              >
                {jobs.ec2.list.map((m, i) => (
                  <Option key={i} value={m.instance_id}>
                    {m.name} [instance: {m.instance_id}]
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col sm={24} md={6} lg={6} xl={6} className="text-center xs-m-top-10">
            <Button type="primary" onClick={this.reset} className="pull-right">
              Reset
            </Button>
            <Popconfirm
              placement="left"
              title="Are you sure want to restart selected machine(s)?"
              onConfirm={this.confirm}
              onCancel={this.cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button type="primary" className="pull-right margin-right-10">
                Restart Machine(s)
              </Button>
            </Popconfirm>
          </Col>
        </Row>
        <Row>
          <Col span={24} className="margin-bottom-10">
            <Alert
              message={
                <a
                  href="https://docs.google.com/document/d/1qxJj3vEJ6F9NVmlyWAV6LhihHPPWjnSW00TA5c6Ue9A/edit"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Steps to add job below for monitoring
                </a>
              }
              type="info"
              showIcon
            />
          </Col>
          <Col span={24}>
            {jobs.isFetching ? (
              <Spin indicator={antIcon} />
            ) : (
              <Fragment>
                {jobs.list.length <= 0 ? (
                  <div>&nbsp; No Data</div>
                ) : (
                  <Fragment>
                    <table className={`ant-table ant-table-small width-100pt`}>
                      <thead className="ant-table-thead">
                        <tr>
                          {columns.map((item, i) => (
                            <th
                              className="padding-8"
                              key={i}
                              onClick={e => this._jobSorting(e, item.key)}
                            >
                              {item.title}
                              <Icon type="sort-ascending" />
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="ant-table-tbody">
                        {jobs.list.map((state, i) =>
                          state.list.length > 0 ? (
                            <Fragment key={i}>
                              <tr key={i}>
                                <td
                                  colSpan="7"
                                  className="padding-8"
                                  align="center"
                                >
                                  {state.name}
                                </td>
                              </tr>
                              {state.list.map((item, j) => (
                                <tr key={j}>
                                  <td className="padding-8">{item.name}</td>
                                  <td className="padding-8">{item.state}</td>
                                  <td className="padding-8">{item.started}</td>
                                  <td className="padding-8">{item.current}</td>
                                  <td className="padding-8">{item.updated}</td>
                                  <td className="padding-8">{item.server}</td>
                                  <td className="padding-8">{item.url}</td>
                                </tr>
                              ))}
                            </Fragment>
                          ) : null
                        )}
                      </tbody>
                    </table>
                  </Fragment>
                )}
              </Fragment>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

Jobs.propTypes = {
  jobs: PropTypes.object,
  config: PropTypes.object,
  match: PropTypes.object,
  fetchJobs: PropTypes.func,
  sortingChange: PropTypes.func,
  sortingJobs: PropTypes.func,
  fetchEc2Machine: PropTypes.func,
  rebootMachine: PropTypes.func
};

Jobs.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  jobs: state.session.jobs
});

const mapDispatchToProps = dispatch => ({
  fetchJobs: () => dispatch(fetchJobs()),
  sortingChange: data => dispatch(sortingChange(data)),
  sortingJobs: () => dispatch(sortingJobs()),
  fetchEc2Machine: () => dispatch(fetchEc2Machine()),
  rebootMachine: data => dispatch(rebootMachine(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Jobs));
